import { Component, OnInit, Input, Output, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { AppService, AppDateAdapter, APP_DATE_FORMATS } from "../../../../services/app.service";
import { ShipperService } from "../../../../services/shipper.service";
import { MasterService } from "../../../../services/master.service";
import { OrderService } from "../../../../services/order.service";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material";


@Component({
    selector: "app-order-detail",
    templateUrl: "./order-detail.component.html",
    styleUrls: ["./order-detail.component.scss"],
    providers: [
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
        }
    ]
})
export class OrderDetailComponent implements OnInit {
    @Input() parent: any;

shipperList: any = [];
orderStatusList: any = [];
orderTypeList: any = [];
articalList: any = [];
formGroup: FormGroup;
formGroupErrors: any;

oldShipperOrderNumber: string = "";

translations: any;
otColor = '';
oStatus = '';

isExists: Boolean = false;
canUpdateToDelivered: Boolean = true;

constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    public shipperService: ShipperService,
    public masterService : MasterService,
    public orderService : OrderService
) {
    this.appService.showLoading();
    this.setPageTranslations();

    this.formGroupErrors = {
        OrderNo: {},
        RegistrationDate: {},
        ShipperId: {},
        InvoiceNo: {},
        AticleId: {},
        TypeId: {},
        Status: {},
        D_PlannedDate: {},
        D_ActualDate: {},
    };
}

ngOnInit() {
    
    this.loadFormGroup();
    this.bindOrderStatus();
    this.bindShipper();

    this.bindOrderType();
    this.bindArticle();
    this.oldShipperOrderNumber = this.parent.order.InvoiceNo != undefined ? this.parent.order.InvoiceNo : "";
    this.appService.hideLoading();
}

setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}

bindShipper(): void {
    this.shipperService
    .list(this.parent.order.ShipperId)
    .subscribe(
    res => this.getShipperDetailsSuccess(res),
    error => this.apiFaillure(error)
    );
}

getShipperDetailsSuccess(res): void {
    if (res.Data != null) {
        this.shipperList = JSON.parse(res.Data);
        if(this.parent.order.ShipperId <= 0){
            this.parent.order.ShipperId = this.shipperList[0]['Id'];
        }
        
    } else {
    this.apiFaillure(res.Message);
}
}

apiFaillure(error): void {
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}

bindOrderStatus(): void {
    this.masterService
    .selectSysData("OrderStatus",this.parent.order.Status)
    .subscribe(
    res => this.getOrderStatussSuccess(res),
    error => this.apiFaillure(error)
    );
}

getOrderStatussSuccess(res): void {
    if (res.Data != null) {
        this.orderStatusList = JSON.parse(res.Data);
        for(let i = 0; i< this.orderStatusList.length; i++){
            if(this.parent.order.Status == this.orderStatusList[i].Id)
            {
                this.oStatus = this.orderStatusList[i].Value;
            }
        }  

    } else {
    this.apiFaillure(res.Message);
}
}

bindOrderType(): void {
    this.masterService
    .selectSysData("OrderType",this.parent.order.TypeId)
    .subscribe(
    res => this.getOrderTypesSuccess(res),
    error => this.apiFaillure(error)
    );
}
getOrderTypesSuccess(res): void {
    if (res.Data != null) {
        this.orderTypeList = JSON.parse(res.Data);
        for(let i = 0; i< this.orderTypeList.length; i++){
            if(this.parent.order.TypeId == this.orderTypeList[i].Id)
            {
                this.otColor = this.orderTypeList[i].Value;
            }
        }      
    } else {
    this.apiFaillure(res.Message);
}
}

bindArticle(): void {
    this.masterService
    .selectSysData("Article",this.parent.order.AticleId)
    .subscribe(
    res => this.getArticlesSuccess(res),
    error => this.apiFaillure(error)
    );
}
getArticlesSuccess(res): void {
    if (res.Data != null) {
        this.articalList = JSON.parse(res.Data);
    } else {
    this.apiFaillure(res.Message);
}
}

buildFormGroup(){
    if (this.parent.order.Status == 152) {
        this.formGroup = this.formBuilder.group({
            OrderNo: [{ value: '', disabled: true }],
            RegistrationDate: ["", Validators.required],
            ShipperId: [{ value: '', disabled: true }, Validators.required],
            InvoiceNo: ["", Validators.required],
            AticleId: ["", Validators.required],
            TypeId: ["", Validators.required],
            Status: ["", Validators.required],
            D_PlannedDate: ["", Validators.required],
            D_ActualDate: ["", Validators.required]
        });
    }
    else{
         this.formGroup = this.formBuilder.group({
            OrderNo: [{ value: '', disabled: true }],
            RegistrationDate: ["", Validators.required],
            ShipperId: [{ value: '', disabled: true }, Validators.required],
            InvoiceNo: ["", Validators.required],
            AticleId: ["", Validators.required],
            TypeId: ["", Validators.required],
            Status: ["", Validators.required],
            D_PlannedDate: [{value: "", disabled: true }],
            D_ActualDate: [{value: "", disabled: true }]
         });   
    }
}

loadFormGroup() {
    this.buildFormGroup();
    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(this.formGroup, this.formGroupErrors);  
        this.parent._orderFormInvalid =  this.formGroup.invalid;
        this.appService.setFormValid(this.formGroup.invalid);
    });

}

canChangeStatusToDelivered(status){
    if(status == 152){ 
        if((this.parent.order.D_ShipDate != undefined && this.parent.order.D_ShipDate != "") && 
           (this.parent.order.D_LicensePlate != undefined && this.parent.order.D_LicensePlate != "") && 
           (this.parent.order.D_T2No != undefined && this.parent.order.D_T2No != "") && 
           (this.parent.order.D_ReceiveDate != undefined && this.parent.order.D_ReceiveDate != "") && 
           (this.parent.order.D_PlannedDate != undefined && this.parent.order.D_PlannedDate != "") && 
           (this.parent.order.D_ActualDate != undefined && this.parent.order.D_ActualDate != "")){
            return true;              
        }else
            return false;
    }else
        return true;
}

changeColor(e){
    // this.canUpdateToDelivered = this.canChangeStatusToDelivered(e.value);
    // this.parent.showOrderDeliveredStatusDialog(!this.canUpdateToDelivered);

     // if (this.parent.order.Status == 152) {
     //        this.formGroup = this.formBuilder.group({
     //            D_ActualDate: [Validators.required]
     //        });
     //    }
     //    else{
     //         this.formGroup = this.formBuilder.group({
     //            D_PlannedDate: [{disabled: true }],
     //            D_ActualDate: [{disabled: true }]
     //        });   
     //    }

    for(let i = 0; i< e.source.options.length; i++){
        if(e.value == e.source.options._results[i].value)
        {
            e.source._elementRef.nativeElement.firstElementChild.firstElementChild.style.color =  e.source.options._results[i]._element.nativeElement.style.color;
        }
    }
}

validate(shipperOrderNumber){
    if(this.oldShipperOrderNumber.toString().toLowerCase() == shipperOrderNumber.toString().toLowerCase())
        this.isExists = false;
    else
    {
        this.orderService.isSORDNUMExists(shipperOrderNumber).subscribe(
            res => this.validationSuccess(res),
            error => this.apiFaillure(error)
        );
    }
}

validationSuccess(res){
    this.isExists = res.Status == -1 ? true : false;
    this.appService.setFormValid(this.isExists);
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/order-detail/order-detail.component.ts